import { navigate } from "gatsby"
import React, { useEffect } from "react"
import { useSiteLocation } from "../../hooks"
import QuoteSection from "../quote-section"

const EmbedSingersVideo = ({ htmlContent, location }) => {
  const siteLocation = useSiteLocation(location)

  const onListenMessageIframe = e => {
    if (e.data.message === "IsSelectedItemOnSingerPage" && e.data.value) {
      navigate("/quote/", {
        state: {
          openSingerModal: true,
        },
      })
    }
  }

  useEffect(() => {
    window.addEventListener("message", onListenMessageIframe)
    return () => window.removeEventListener("message", onListenMessageIframe)
  }, [])

  return (
    <div>
      <div
        className="max-w-screen-2xl mx-auto px-7 font-light"
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
      <QuoteSection
        src={`${process.env.GATSBY_BACKSTAGE_URL}/${siteLocation}/static-singers`}
        className="static-ceremony-iframe mt-5 max-w-screen-2xl mx-auto md:px-0 px-7"
        title="static-singers"
        allowFullScreen="allowfullscreen"
      />
    </div>
  )
}

export default EmbedSingersVideo
